import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'
import _ from 'lodash'

const state = {
  alerts: [],
  alert: {},
  alert_action_types: [],
  alert_steps: [],
  alert_step: {},
  alert_step_order_types: [],
  alert_step_command_types: [],
  guided_states: {
    ASK_CREATE_VISUALS: 'ASK_CREATE_VISUALS',
    ASK_CREATE_STEPS: 'ASK_CREATE_STEPS',
    ASK_CREATE_STEPS_AFTER_VISUAL: 'ASK_CREATE_STEPS_AFTER_VISUAL',
    ASK_CREATE_ANOTHER_VISUAL: 'ASK_CREATE_ANOTHER_VISUAL',
    ASK_CREATE_ANOTHER_STEP: 'ASK_CREATE_ANOTHER_STEP'
  }
}

const getters = {
  allAlerts: state => state.alerts,
  singleAlert: state => state.alert,
  allAlertSteps: state => state.alert_steps,
  allAlertActionTypes: state => state.alert_action_types,
  singleAlertStep: state => state.alert_step,
  allAlertStepOrderTypes: state => state.alert_step_order_types,
  allAlertStepCommandTypes: state => state.alert_step_command_types,
  allGuidedStates: state => state.guided_states
}

const actions = {
  getAlerts ({ commit }) {
    api.instance.get('alerts')
      .then(function (response) {
        const alerts = response.data.alerts
        commit(types.RECEIVE_ALERTS, alerts)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getAlert ({ commit }, alertId) {
    api.instance.get('alerts/' + alertId)
      .then(function (response) {
        const alert = response.data.alert

        if (alert.extension === 0) {
          alert.extension = '9'
        }

        commit(types.RECEIVE_ALERT, alert)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditAlert ({ commit, rootGetters }, data) {
    let alertData = data.alert

    alertData.site_id = rootGetters.scopedSiteId

    if (alertData.extension === '') {
      alertData.extension = '9'
    }

    if (alertData.extension === '9') {
      alertData.extension = 0
    }

    if (alertData.name !== '') {
      if (alertData.alert_id === 0) {
        api.instance.post('alerts', alertData)
          .then(function (response) {
            if (response.data.success === 'true') {
              alertData = response.data.alert[0]
              commit(types.ADD_ALERT, alertData)

              if (data.next === 'AdvancedVisualAdd') {
                router.push({ name: 'AdvancedVisualAdd', params: { alert_id: alertData.alert_id } })
              } else if (data.next === 'AlertStepAdd') {
                router.push({ name: 'AlertStepAdd', params: { alert_id: alertData.alert_id, alert_step_order_type_id: 1 } })
              } else {
                router.push({ name: 'AlertIndex' })
              }
            } else {
              alert(response.data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        api.instance.put('alerts/' + alertData.alert_id, alertData)
          .then(function (response) {
            if (response.data.success === 'true') {
              alertData = response.data.alert[0]
              commit(types.EDIT_ALERT, alertData)
              alert('Successfully saved.')
            } else {
              alert(response.data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    } else {
      alert('Name is required')
    }
  },
  deleteAlert ({ commit }, _alert) {
    api.instance.delete('alerts/' + _alert.alert_id)
      .then(function (response) {
        alert(response.data.message)

        if (response.data.success === 'true') {
          commit(types.DELETE_ALERT, _alert)
        }
      })
  },
  getAlertActionTypes ({ commit }) {
    if (!Array.isArray(state.alert_action_types) || !state.alert_action_types.length) {
      api.instance.get('alert_action_types')
        .then(function (response) {
          const alertActionTypes = response.data.alert_action_types
          commit(types.RECEIVE_ALERT_ACTION_TYPES, alertActionTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getAlertSteps ({ commit }, alertId) {
    api.instance.get('alert_steps_by_alert/' + alertId)
      .then(function (response) {
        const alertSteps = response.data.alert_steps
        commit(types.RECEIVE_ALERT_STEPS, alertSteps)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getAlertStep ({ commit }, alertStepId) {
    api.instance.get('alert_steps/' + alertStepId)
      .then(function (response) {
        const alertStep = response.data.alert_step

        if (!alertStep.barix_command) alertStep.barix_command = ''
        if (!alertStep.sleep_duration) alertStep.sleep_duration = 0
        if (!alertStep.to_alert_step_id) alertStep.to_alert_step_id = 0
        if (!alertStep.message) alertStep.message = ''
        if (!alertStep.alert_step_phone_numbers) alertStep.alert_step_phone_numbers = []
        if (!alertStep.visual_id) alertStep.visual_id = 0
        if (!alertStep.advanced_visual_id) alertStep.advanced_visual_id = 0
        if (!alertStep.zone_id) alertStep.zone_id = 0
        if (!alertStep.sound_id) alertStep.sound_id = 0

        if (alertStep.alert_step_command_type_id === 1) {
          alertStep.sound = {
            value: alertStep.sound.sound_id,
            label: alertStep.sound.filename
          }
        }

        commit(types.RECEIVE_ALERT_STEP, alertStep)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditAlertStep ({ commit, dispatch }, data) {
    let alertStep = data.alert_step
    if (alertStep.alert_step_command_type_id === 0) {
      alert('Command Type is required.')
      return
    }

    if (alertStep.alert_step_command_type_id === 1) {
      alertStep.sound_id = alertStep.sound.value
    }

    if (alertStep.alert_step_command_type_id === 1 &&
      (alertStep.zone_id === 0 ||
        (alertStep.sound === '' && alertStep.sound_id === 0 && alertStep.sound_id === '0'))) {
      alert('Zone and Sound are required.')
      return
    }

    if (alertStep.alert_step_command_type_id === 2 &&
      alertStep.barix_command === '') {
      alert('Barix Command is required.')
      return
    }

    if (alertStep.alert_step_command_type_id === 3 &&
      alertStep.sleep_duration <= 0) {
      alert('Sleep Duration is required and must be greater than 0.')
      return
    }

    if (alertStep.alert_step_command_type_id === 4 &&
      alertStep.to_alert_step_id === 0) {
      alert('Go to step is required.')
      return
    }

    if (alertStep.alert_step_command_type_id === 5) {
      if (_.isEmpty(alertStep.message)) {
        alert('Message is required')
        return
      }
    }

    if ([7, 8].includes(alertStep.alert_step_command_type_id) && (alertStep.zone_id === 0 || alertStep.advanced_visual_id === 0)) {
      alert('Zone and Visual are required')
      return
    }

    if (alertStep.alert_step_command_type_id === 11 && (alertStep.display_text === '' || alertStep.flasher_type === '')) {
      alert('Display Text and Flasher Type are required')
      return 
    }

    if (alertStep.alert_step_command_type_id === 10) {
      alert('Warning: If you do not enable the system after this step, most features will not work until the service is manually restarted.')
    }

    if (alertStep.alert_step_id === 0) {
      api.instance.post('alert_steps', alertStep)
        .then(function (response) {
          if (response.data.success === 'true') {
            alertStep = response.data.alert_step[0]
            commit(types.ADD_ALERT_STEP, alertStep)
            router.push({ name: 'Reset', params: { to_name: data.next, to_pass_params: { alert_id: alertStep.alert_id } } })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      api.instance.put('alert_steps/' + alertStep.alert_step_id, alertStep)
        .then(function (response) {
          if (response.data.success === 'true') {
            alertStep = response.data.alert_step[0]
            commit(types.EDIT_ALERT_STEP, alertStep)
            dispatch('getAlertSteps', alertStep.alert_id, { root: true })
            $('#editAlertStepModal').modal('hide')
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteAlertStep ({ commit }, alertStep) {
    api.instance.delete('alert_steps/' + alertStep.alert_step_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_ALERT_STEP, alertStep)
        }
      })
  },
  getAlertStepOrderTypes ({ commit }) {
    if (!Array.isArray(state.alert_step_order_types) || !state.alert_step_order_types.length) {
      api.instance.get('alert_step_order_types')
        .then(function (response) {
          const alertStepOrderTypes = response.data.alert_step_order_types
          commit(types.RECEIVE_ALERT_STEP_ORDER_TYPES, alertStepOrderTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getAlertStepCommandTypes ({ commit }) {
    if (!Array.isArray(state.alert_step_command_types) || !state.alert_step_command_types.length) {
      api.instance.get('alert_step_command_types')
        .then(function (response) {
          const alertStepCommandTypes = response.data.alert_step_command_types
          commit(types.RECEIVE_ALERT_STEP_COMMAND_TYPES, alertStepCommandTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  reorderAlertStep ({ commit, state }, params) {
    api.instance.put('alert_steps/order/' + params.alert_step_id, { direction: params.direction })
      .then(function (response) {
        if (response.data.success === 'true') {
          let alertSteps = response.data.alert_steps
          commit(types.RECEIVE_ALERT_STEPS, alertSteps)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  executeAlert ({ rootGetters }, alertId) {
    api.instance.post('uds_message', {
      command: 'execute_alert',
      alert_id: alertId,
      source_id: 2,
      source_user: rootGetters.loggedInUser.username
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Alert successfully executed.')
        /* eslint-disable-next-line */
        $('#textToSpeechModal').modal('hide')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  }
}

const mutations = {
  [types.RECEIVE_ALERTS] (state, alerts) {
    state.alerts = alerts
    state.alerts_received_timestamp = new Date()
  },
  [types.RECEIVE_ALERT] (state, alert) {
    state.alert = alert
  },
  [types.ADD_ALERT] (state, alert) {
    state.alerts.push(alert)
  },
  [types.EDIT_ALERT] (state, alert) {
    let alertToEdit = state.alerts.find(
      function (ele) {
        if (ele.alert_id === alert.alert_id) {
          return true
        }
      }
    )
    let index = state.alerts.indexOf(alertToEdit)
    state.alerts[index] = alert
  },
  [types.DELETE_ALERT] (state, alert) {
    let alertToDelete = state.alerts.find(
      function (ele) {
        if (ele.alert_id === alert.alert_id) {
          return true
        }
      }
    )
    let index = state.alerts.indexOf(alertToDelete)
    state.alerts.splice(index, 1)
  },
  [types.RECEIVE_ALERT_ACTION_TYPES] (state, alertActionTypes) {
    state.alert_action_types = alertActionTypes
  },
  [types.RECEIVE_ALERT_STEPS] (state, alertSteps) {
    state.alert_steps = alertSteps
  },
  [types.RECEIVE_ALERT_STEP] (state, alertStep) {
    state.alert_step = alertStep
  },
  [types.ADD_ALERT_STEP] (state, alertStep) {
    state.alert_steps.push(alertStep)
  },
  [types.EDIT_ALERT_STEP] (state, alertStep) {
    let alertStepToEdit = state.alert_steps.find(
      function (ele) {
        if (ele.alert_step_id === alertStep.alert_step_id) {
          return true
        }
      }
    )
    let index = state.alert_steps.indexOf(alertStepToEdit)
    state.alert_steps[index] = alertStep
  },
  [types.DELETE_ALERT_STEP] (state, alertStep) {
    let alertStepToDelete = state.alert_steps.find(
      function (ele) {
        if (ele.alert_step_id === alertStep.alert_step_id) {
          return true
        }
      }
    )
    let index = state.alert_steps.indexOf(alertStepToDelete)
    state.alert_steps.splice(index, 1)
  },
  [types.RECEIVE_ALERT_STEP_ORDER_TYPES] (state, alertStepOrderTypes) {
    state.alert_step_order_types = alertStepOrderTypes
  },
  [types.RECEIVE_ALERT_STEP_COMMAND_TYPES] (state, alertStepCommandTypes) {
    state.alert_step_command_types = alertStepCommandTypes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
